import * as React from 'react';
import LottieAnimation from '../assets/Animations/Lottie';
import animationData from '../assets/Animations/lurking-cat';
import ImageGridComp from './NewMix'



export default class MixPhotos extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        isLoading: true
    };
  }



  componentDidMount(){
    document.getElementById("myBar").style.display = "block";
    document.getElementById("road").style.display = "block";
    setTimeout(() => {
        this.setState({isLoading: false})
    }, 5000);
  }



  render(){
    return (
      this.state.isLoading ? <LottieAnimation lotti={animationData} height={'auto'} width={'40%'} isloop={true}/>
            :
        <div id="mix">
          <ImageGridComp />
        </div>
    );
  }
}



